export default "__VITE_ASSET__BU0Eyiy0__"